import Vuex from "vuex";
import Vue from "vue";
import router from "@/router";
import { mapMenu } from "@/store/map-menu.js";
import { getUserInfo, login, loginCode } from "@/views/login/api";
import { getDictPageAll } from "@/views/commonApi"; //前面封装的函数
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    sycRoutes: [],
    message: [], // socket推送的信息
  },
  mutations: {
    SET_MESSAGE(state, message) {
      // console.log("SET_MESSAGE", message);
      state.message = message;
    },
  },
  actions: {
    // setRoutes({ commit }, data) {
    //   return new Promise((resolve) => {
    //     // console.log("data", data);
    //     router.addRoute(mapMenu(data));
    //     resolve();
    //   });
    // },
    getMessage({ dispatch, commit }, info) {
      commit("SET_MESSAGE", info);
    },
    // 生成路由
    login({ commit }, formData) {
      return new Promise((resolve, reject) => {
        // 向后端请求路由数据
        login(formData)
          .then((res) => {
            if (res.code === 200) {
              resolve(res.data);
            } else {
              reject(false);
            }
          })
          .catch((_) => {
            reject(false);
          });
      });
    },
    loginCode({ commit }, formData) {
      return new Promise((resolve, reject) => {
        // 向后端请求路由数据
        loginCode(formData)
          .then((res) => {
            if (res.code === 200) {
              localStorage.setItem("token", res.data.accessToken);
              localStorage.setItem("refreshToken", res.data.refreshToken);
              resolve(res.data);
            } else {
              reject(false);
            }
          })
          .catch((_) => {
            reject(false);
          });
      });
    },
    getUserData({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            if (res.code === 200) {
              resolve(res.data);
            } else {
              reject(false);
            }
          })
          .catch((_) => {
            reject(false);
          });
      });
    },
    getDicts({ commit }) {
      return new Promise((resolve) => {
        getDictPageAll().then((res) => {
          if (res.code === 200) {
            localStorage.setItem("dict", JSON.stringify(res.data));
          }
        });
      });
    },
  },
});

export default store;
